/*eslint-disable*/
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import axios from "axios";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import GetAppIcon from '@material-ui/icons/GetApp';
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CustomInput from "components/CustomInput/CustomInput.js";
import Slide from "@material-ui/core/Slide";

import SchoolIcon from '@material-ui/icons/School';
import ComputerIcon from '@material-ui/icons/Computer';
import TodayIcon from '@material-ui/icons/Today';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';
// core components
import InfoArea from "components/InfoArea/InfoArea.js";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import SectionFooter from "views/footer/PageFooter.js"

import presentationStyle from "assets/jss/material-kit-pro-react/views/echosup/SecretaireMedicaleStyle.js";

import logo_ecosup from "assets/img/ecosup.png";

import imgSecMed from "assets/img/juridique.jpg";


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(presentationStyle);

export default function Juridique() {
  React.useEffect(() => {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  retrieveSessions();
},[]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalDownload, setModalDownload] = React.useState(false);
  const [data, setData] = useState({ nom: "", prenom: "", email:"", phone:""});
  const [errors, setErrors] = useState({});

  function handleValidation(){
    let formIsValid = true;
    let errors = {};

    //Name
    let name = `${data.nom}`;
    if(name.trim() == ""){
       formIsValid = false;
       errors["name"] = "*Veuillez entrer un nom";
    }else{
      if(typeof name !== "undefined"){
         if(!name.match(/^[a-zA-Z]+$/)){
            formIsValid = false;
            errors["name"] = "*Le nom doit comporter uniquement des caratères";
         }
      }
    }

    //Prenom
    let prenom = `${data.prenom}`;
    if(prenom.trim() == ""){
       formIsValid = false;
       errors["prenom"] = "*Veuillez entrer un prénom";
    }else{
      if(typeof prenom !== "undefined"){
         if(!prenom.match(/^[a-zA-Z]+$/)){
            formIsValid = false;
            errors["prenom"] = "*Le prénom doit comporter uniquement des caratères";
         }
      }
    }

    //Email
    let email = `${data.email}`;
    if(email.trim() == ""){
       formIsValid = false;
       errors["email"] = "*Veuillez entrer une adresse email";
    }else{
      if(typeof email !== "undefined"){
         let lastAtPos = email.lastIndexOf('@');
         let lastDotPos = email.lastIndexOf('.');

         if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
            formIsValid = false;
            errors["email"] = "*Veuillez entrer une adresse email valide";
          }
     }
    }

    //Phone
    let phone = `${data.phone}`;
    if(phone.trim() == ""){
       formIsValid = false;
       errors["phone"] = "*Veuillez entrer un numéro de téléphone";
    }else{
      if(typeof phone !== "undefined"){
         if(!phone.match(/^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/)){
            formIsValid = false;
            errors["phone"] = "*Veuillez entrer un numéro de téléphone valide";
         }
      }
    }

    if(!checkbox){
      formIsValid = false;
      errors["checkbox"] = "*Veuillez acceptez l'enregistrement de vos informations";
    }

   setErrors(errors);
   console.log(errors);
   return formIsValid;
  }

  const [checkbox, setCheckbox] = useState(false);
  const handleCheckbox = (event) => {
    errors["checkbox"]="";
    setCheckbox(event.target.checked);
  };

  function download() {
    let isValid = handleValidation();
    if(isValid){
      window.open(`${global.url_plaquette_aj}`);
      setIsLoading(true);
      const dataForm = new FormData();
      dataForm.append('data', JSON.stringify({
           nom: `${data.nom}`,
           prenom: `${data.prenom}`,
           email: `${data.email}`,
           phone: `${data.phone}`,
           formation: 5
         }))

      axios.post(`${global.API_URL}/downloads`,dataForm
      ).then(function(response){
      console.log('Success!');
      setModalDownload(false);
      setIsLoading(false);
    })
    .catch(function(){
      console.log('Fail!');
    });
    }
  }

  const [sessions, setSessions] = useState([]);
  const [inscriptionEnabled, setInscriptionEnabled] = useState(false);
  function retrieveSessions()
  {
    let userjwt = localStorage.getItem('jwt');
    axios.get(`${global.API_URL}/session-informations`)
    .then(res => {

      let listSessions = [];
      for (let [index,session] of res.data.entries()) {
        console.log(session);

        const isFound = session.formations.some(element => {
          if (element.id === 6) {
            return true;
          }
        });

        if(isFound){
          let date = moment(session.date).format('DD/MM/yyyy');
          let time = moment(session.date).format('HH:mm');
          let s={text:date+" "+time,id:session.id};
          listSessions.push(s);
        }
      }
      if(listSessions.length>0)setInscriptionEnabled(true);
      setSessions(listSessions);
    });
  }

  const [sessionSelect, setSessionSelect] = React.useState("");
  const handleSessionSelect = event => {
    let code = event.target.value;
    setSessionSelect(event.target.value);
    console.log("Session : "+code);
  }

  const [modalInscription, setModalInscription] = React.useState(false);
  function registerRDV(){
    let isValid = handleValidation();
    if(isValid){
      setIsLoading(true);
      const dataForm = new FormData();
      dataForm.append('data', JSON.stringify({
           nom: `${data.nom}`,
           prenom: `${data.prenom}`,
           email: `${data.email}`,
           phone: `${data.phone}`,
           session_information: sessionSelect
         }))

      axios.post(`${global.API_URL}/rdv-sessions`,dataForm
      ).then(function(response){
      console.log('Success!');
      setModalInscription(false);
      setSuccessRegister(true);
      setIsLoading(false);
    })
    .catch(function(){
      console.log('Fail!');
    });
    }
  }

  const [successRegister, setSuccessRegister] = useState(false);
  const handleCloseRegister = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessRegister(false);
  };

  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <title>Assistant Juridique Toulon - Formation niveau 5 en alternance | EcoSup</title>
        <meta name="description" content="Formation Assistant Juridique en alternance à Toulon. Certification niveau 5 (RNCP 40249). 18 à 22 mois pour maîtriser la gestion juridique." />
        <link rel="canonical" href="https://www.ecosup-toulon.fr/juridique" />
      </Helmet>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 50,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/juridique.jpg")}
        className={classes.parallax}
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <GridContainer justify="center" alignItems="center">
                  <GridItem xs={8} sm={4} md={4}>
                    <img
                      src={logo_ecosup} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={8}>
                    <h1 className={classes.title}>
                      Assistant(e) juridique
                    </h1>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.section}>
          <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={8} md={8}>
            <h3 className={classes.title2}>Prérequis</h3>
            <div className={classes.features}>
              <GridContainer>
              <GridItem xs={4} sm={4} md={4}>
                  <InfoArea
                    vertical
                    icon={AssignmentIcon}
                    description="Réussite aux tests d'admission"
                    iconColor="juridique"
                  />
                </GridItem>
              <GridItem xs={4} sm={4} md={4}>
                  <InfoArea
                    vertical
                    icon={PeopleIcon}
                    description="Âgé(e) d'au moins de 18 ans"
                    iconColor="juridique"
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <InfoArea
                    vertical
                    icon={ComputerIcon}
                    description="Maîtrise de l’outil informatique et bonne orthographe"
                    iconColor="juridique"
                  />
                </GridItem>
              </GridContainer>

            </div>
            <h3 className={classes.cardTitle}>Présentation</h3>
            <h5 className={classes.description}>L’assistant(e) juridique garantit la bonne gestion administrative et juridique du cabinet ou du service de toutes entreprises. Au centre de l’information il ou elle doit respecter scrupuleusement le secret professionnel et l’éthique très importante de ce secteur d’activité.</h5>
            <h3 className={classes.cardTitle}>Type de diplôme</h3>
            <p className={classes.description}>Certification professionnelle de niveau 5 , numéro RNCP 40249 , assistant(e) juridique délivrée par Ecole Vidal-Vidal formation enregistrée le 28.02.2025 au Répertoire National des Certifications Professionnelles (RNCP) par France Compétences, autorité de régulation et de financement de la formation professionnelle et de l’apprentissage.</p>
           <h3 className={classes.cardTitle}>Contenu de la formation</h3>
            <h4 className={classes.description}><b>Autoformation 28h</b></h4>
            <p className={classes.description}>• Introduction au Droit</p>
            <p className={classes.description}>• Office basic (bureautique)</p>
            <p className={classes.description}>• Introduction au secrétariat</p>
            <h4 className={classes.description}><b>Autoévaluation</b></h4>
            <p className={classes.description}>• Quizz Introduction au Droit (Kahoot) + corrigé</p>
            <p className={classes.description}>• Office Quizz (schémas à compléter, QCM, vrai-faux) + Office Solution</p>
            <p className={classes.description}>• Quizz Introduction au Secrétariat (Kahoot) + corrigé</p>
            <p className={classes.description}>N.B. Utiliser comme tests de positionnement dans les blocs de compétences concernés.</p>
            <br/>
            <br/>
            <h4 className={classes.description}><b>Bloc 1 Assurer l’interface entre l’équipe juridique et ses interlocuteurs 116h</b></h4>
            <p className={classes.description}>✓ Prise en charge des demandes entrantes 48h</p>
            <p className={classes.description}>✓ Accueillir un interlocuteur 24h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;Intitulé du cours : deux supports :</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  -  Accueillir un interlocuteur 12h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  -  La communication orale 12h</p>
            <p className={classes.description}>✓ Communiquer les informations juridiques 12h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Communiquer les informations juridiques</p>
            <p className={classes.description}>✓ Adapter son attitude 12h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Adapter son attitude aux situations spécifiques</p>
            <p className={classes.description}>✓ Gestion des demandes entrantes 28h</p>
            <p className={classes.description}>✓ Traiter les demandes 16h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : deux supports :</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp; -  Traiter les demandes 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  -  L’usage de l’I.A. générative dans la prise en charge et la gestion des demandes entrantes 8h</p>
            <p className={classes.description}>✓ Gérer les agendas 12h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Gérer les agendas</p>
            <p className={classes.description}>✓ Communication digitale externe 32h</p>
            <p className={classes.description}>✓ Déployer la communication externe 12h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Déployer la communication externe</p>
            <p className={classes.description}>✓ Rédiger un support de communication 20h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : deux supports :</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  -  Rédiger un support de communication 12h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  -  L’usage de l'IA générative dans la communication digitale externe 8h</p>
            <p className={classes.description}>+ Enseignement transverse : Projet Voltaire 8h : maîtrise du français</p>
            <br/>
            <h4 className={classes.description}><b>Bloc 2 Organiser la gestion administrative de l’entité 120h</b></h4>
            <p className={classes.description}>✓ Partage de l’information écrite 48h</p>
            <p className={classes.description}>✓ Concevoir et formaliser des documents écrits professionnels 24h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : trois supports :</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;- La communication professionnelle écrite – Introduction 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;- La communication professionnelle écrite interne 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;- La communication professionnelle écrite externe 8h</p>               
            <p className={classes.description}>✓ Déployer la communication digitale interne 24h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Déployer la communication digitale interne</p>
            <p className={classes.description}>✓ Conservation de l’information 28h</p>
            <p className={classes.description}>✓ Organiser la traçabilité documentaire 14h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Organiser la traçabilité documentaire + PDF "Guide sécurité personnelle 2024 - CNIL"</p>
            <p className={classes.description}>✓ Archiver les documents 14h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : L'archivage + PDF "Guide durées de conservation - CNIL"</p>
            <p className={classes.description}>✓ planification des activités 16h</p>
            <p className={classes.description}>✓ Organiser les activités usuelles de l’équipe 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : deux supports :</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp; - Coordonner les activités courantes de l'équipe – Les congés 4h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;- Coordonner les activités courantes de l'équipe – Les réunions et les salles 4h</p>
            <p className={classes.description}>✓ Organiser les activités exceptionnelles de l’équipe 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Gérer la logistique des activités exceptionnelles de l'équipe</p>
            <p className={classes.description}>+ Enseignements transverses : </p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Bureautique - Word et Excel 20h : maîtrise professionnelle des logiciels</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Projet Voltaire 8h : maîtrise du français</p>
            <br/>
            <h4 className={classes.description}><b>Bloc 3 Organiser la gestion commerciale et financière de l’entité 148h</b></h4>
            <p className={classes.description}>✓ Administration des ventes 56h</p>
            <p className={classes.description}>✓ Etablir un devis, une facture et/ou une convention d’honoraires 32h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : deux supports :</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp; - Devis et factures (comptable) 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;- Convention d’honoraires et CARPA (juriste) 24h</p>
            <p className={classes.description}>✓ Concevoir des outils de pilotage 24h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Concevoir des outils de pilotage</p>
            <p className={classes.description}>✓ Administration des achats 16h</p>
            <p className={classes.description}>✓ Réaliser les commandes de fourniture 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Réaliser les commandes de fourniture</p>
            <p className={classes.description}>✓ Contrôler les factures 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Contrôler les factures et autres documents commerciaux</p>
            <p className={classes.description}>✓ Administration des opérations comptables et fiscales 60h</p>
            <p className={classes.description}>✓ Enregistrer les écritures comptables 20h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Enregistrer les écritures comptables</p>
            <p className={classes.description}>✓ Vérifier les différents comptes de tiers 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Vérifier les différents comptes de tiers</p>
            <p className={classes.description}>✓ Etablir la déclaration de TVA 8h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Etablir la déclaration de TVA</p>
            <p className={classes.description}>✓ Interpréter un bilan 24h</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Intitulé du cours : Interpréter un bilan </p>
            <p className={classes.description}>+ Enseignements transverses : </p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Bureautique - Word 8h : maîtrise professionnelle du logiciel</p>
            <p className={classes.description}>&nbsp;&nbsp;&nbsp;  Projet Voltaire 8h : maîtrise du français</p>
            <br/>
            <h4 className={classes.description}><b>Bloc 4 Gérer les dossiers juridiques de la rédaction au suivi procédural 194h</b></h4>
            <p className={classes.description}>✓ Préparation des dossiers juridiques</p>
            <p className={classes.description}>✓ Organiser la veille juridique grâce aux outils digitaux et à l’IA</p>
            <p className={classes.description}>✓ Partager les résultats de la veille</p>
            <p className={classes.description}>✓ Constitution des dossiers juridiques</p>
            <p className={classes.description}>✓ Constituer les dossiers juridiques</p>
            <p className={classes.description}>✓ Utiliser les différents modèles d’actes</p>
            <p className={classes.description}>✓ Actualiser les modèles d’actes</p>
            <p className={classes.description}>✓ Suivi des dossiers juridiques</p>
            <p className={classes.description}>✓ Réaliser le suivi des dossiers</p>
            <p className={classes.description}>✓ Mettre en oeuvre la voie de recours adaptée</p>
            <p className={classes.description}>N.B. Les activités 10, 11 et 12 sont abordées à travers les différents supports pédagogiques de Droit car y sont développées des compétences transversales renvoyant à des spécificités en fonction de la forme de Droit présentée.</p>
            <br/>
            <br/>
            <h4 className={classes.description}><b>Progression pédagogique préconisée et intitulés des cours :</b></h4>
            <p className={classes.description}>1. Le rôle transversal de l’assistant juridique : introduction à la procédure civile – théorie et pratique 32h</p>
            <p className={classes.description}>2. Le rôle transversal de l’assistant juridique : introduction au droit des obligations – théorie et pratique 8h</p>
            <p className={classes.description}>3. Droit administratif 16h</p>
            <p className={classes.description}>4. Droit pénal 16h</p>
            <p className={classes.description}>5. Droit du travail 24h</p>
            <p className={classes.description}>6. Droit de la famille / Juge aux affaires familiales 24h</p>
            <p className={classes.description}>7. Droit notarial (immobilier) 16h</p>
            <p className={classes.description}>8. Commissariat de justice 16h</p>
            <p className={classes.description}>9. Droit des sociétés 30h</p>
            <p className={classes.description}>+ Enseignement transverse : Projet Voltaire 8h : maîtrise du français</p>

            </GridItem>

            <GridItem xs={12} sm={4} md={4}>
              <Card
                backgroundJuridique
                style={{ backgroundImage: `url(${imgSecMed})` }}
              >
                <CardBody background>
                  <h3 className={classes.cardTitleWhite}>
                    Vous souhaitez devenir assistant(e) juridique?
                  </h3>
                  <br/>
                  <h3 className={classes.cardTitleWhite}>
                    Rendez vous à notre prochaine session d'information
                  </h3>
                  <br/>
                  <br/>
                  <p className={classes.cardDescriptionWhite}>
                    <b>Impasse du Docteur Charles Barnier</b>
                  </p>
                  <p className={classes.cardDescriptionWhite}>
                    <b>83000 Toulon</b>
                  </p>
                  <br/>
                  <br/>
                  {inscriptionEnabled ?
                  <Button color="white" round onClick={() => {setModalInscription(true)}}>
                    Je m'inscris
                  </Button> : <h6>pas de session prévue pour l'instant</h6>}
                  <br/>
                  <br/>
                </CardBody>
              </Card>
              <div className={classes.buttonCenter}>
              <Button color="juridique" round onClick={() => {setModalDownload(true)}}>
                <GetAppIcon/>Télécharger la documentation
              </Button>
              </div>
              <h3 className={classes.cardTitle}>Durée du cursus de 18 mois à 22 mois</h3>
              <h5 className={classes.description}>En contrat de professionnalisation si + de 29 ans</h5>
              <h5 className={classes.description}>En contrat d'apprentissage si - de 29 ans</h5>
              <h3 className={classes.cardTitle}>Coût de la formation</h3>
              <h5 className={classes.description}>Les coûts pédagogiques sont pris en charge, dans le cadre de l’alternance, par les Opérateurs de Compétences ( OPCO ).</h5>
                   <h3 className={classes.cardTitle}>
                      Equipe pédagogique & admissions
                    </h3>
                    <h5 className={classes.description}>Chargés relations entreprise : Elise THIEBAUX et Axel BELAÏDI</h5>
                    <h5 className={classes.description}>Chargée du recrutement : Carine TRIPODI</h5>
                    <h5 className={classes.description}>Adjointe de Direction : Camille DUPAIN</h5>
                    <h5 className={classes.description}>Directeur : Olivier DUFOUR</h5>
                    <h5 className={classes.description}>Rélérent Handicap : Olivier DUFOUR et Camille DUPAIN</h5>
              {/* <h3 className={classes.cardTitle}>Tarif</h3>
              <h5 className={classes.description}>Formation en alternance: <b>gratuite</b></h5> */}
              <h3 className={classes.cardTitle}>Débouchés professionnels</h3>
            <p className={classes.description}>À l'issue de cette formation, vous serez capable d'assurer l'interface entre l'équipe juridique et ses interlocuteurs, d'organiser la gestion administrative de l'entité, de mettre en oeuvre
la gestion commerciale et financière de l'entité et de gérer les dossiers juridiques de la rédaction au suivi procédural.</p>
              <h3 className={classes.cardTitle}>Dispositif VAE</h3>
              <h5 className={classes.description}><Link to="/vae">VAE (Validation des Acquis de l'Expérience)</Link></h5>
            </GridItem>
          </GridContainer>
          </div>
        </div>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          open={modalDownload}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModalDownload(false)}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
          maxWidth="md"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
          <h4 className={classes.modalTitle}>Téléchargez la documentation</h4>
          <p className={classes.description}>Veuillez remplir le formulaire pour accéder au téléchargement</p>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
          >
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <CustomInput
                labelText="Nom"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, nom: e.target.value });errors["name"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["name"]}</p>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <CustomInput
                labelText="Prénom"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, prenom: e.target.value });errors["prenom"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["prenom"]}</p>
            </GridItem>
          </GridContainer>
              <CustomInput
                labelText="Téléphone"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, phone: e.target.value });errors["phone"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["phone"]}</p>
              <CustomInput
                labelText="Email"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, email: e.target.value });errors["email"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["email"]}</p>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    onChange={handleCheckbox}
                  />
                }
                label="J'accepte l'enregistrement de mes informations dans la base de données de l'école."
              />
              <p style={{color: "red",fontSize: "12px"}}>{errors["checkbox"]}</p>
              <p className={classes.rgpd}>Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par Ecosup Toulon pour vous tenir informés d'informations importantes relatives à votre admissibilité. Elles sont conservées pendant 1 an et sont destinées au service des admissions. Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : contact@ecosup-toulon.fr Nous vous informons de l’existence de la liste d'opposition au démarchage téléphonique « Bloctel », sur laquelle vous pouvez vous inscrire ici : https://conso.bloctel.fr/</p>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button onClick={() => {download()}} color="aepe" round>
              {isLoading ? "Veuillez patienter ... " : "Téléchargement"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          open={modalInscription}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModalInscription(false)}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
          maxWidth="md"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
          <h4 className={classes.modalTitle}>Réunion d'informations à Toulon</h4>
          <p className={classes.features}>Lieu de la réunion : <b>Ecosup-Toulon</b></p>
          <p className={classes.features}>177 Boulevard Charles Barnier, 83000 Toulon</p>
          <p className={classes.features}>(accés depuis l'impasse Barnier)</p>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
          >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel
                htmlFor="simple-select"
                className={classes.selectLabel}
              >
                Session
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={sessionSelect}
                onChange={handleSessionSelect}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select"
                }}
                >
                {sessions.map((session,index) => (
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected
                    }}
                    value={session.id}
                    key={index}
                  >
                    {session.text}
                  </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <p style={{color: "red",fontSize: "12px"}}>{errors["session"]}</p>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <CustomInput
                labelText="Nom"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, nom: e.target.value });errors["name"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["name"]}</p>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <CustomInput
                labelText="Prénom"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, prenom: e.target.value });errors["prenom"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["prenom"]}</p>
            </GridItem>
          </GridContainer>
              <CustomInput
                labelText="Téléphone"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, phone: e.target.value });errors["phone"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["phone"]}</p>
              <CustomInput
                labelText="Email"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, email: e.target.value });errors["email"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["email"]}</p>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    onChange={handleCheckbox}
                  />
                }
                label="J'accepte l'enregistrement de mes informations dans la base de données de l'école."
              />
              <p style={{color: "red",fontSize: "12px"}}>{errors["checkbox"]}</p>
              <p className={classes.rgpd}>Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par Ecosup Toulon pour vous tenir informés d'informations importantes relatives à votre admissibilité. Elles sont conservées pendant 1 an et sont destinées au service des admissions. Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : contact@ecosup-toulon.fr Nous vous informons de l’existence de la liste d'opposition au démarchage téléphonique « Bloctel », sur laquelle vous pouvez vous inscrire ici : https://conso.bloctel.fr/</p>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button onClick={() => {registerRDV()}} color="aepe" round>
              {isLoading ? "Veuillez patienter ... " : "Inscription"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar open={successRegister} autoHideDuration={5000} onClose={handleCloseRegister}>
        <Alert onClose={handleCloseRegister} severity="success">
          Votre inscription a bien été enregistrée!
        </Alert>
      </Snackbar>
      <SectionFooter date={"11 Février 2026"}/>
    </div>
  );
}
